// GA4 del portal: solo se usa para atribuir el registro por canal, en la
// misma propiedad que la landing (requirement portal-ga4-registro). Sin
// page views: el resto de la medición de producto va por PostHog.
const measurementId = process.env.VUE_APP_GA_MEASUREMENT_ID;
const isEnabled = !!measurementId;

export const SIGN_UP_SENT_STORAGE_PREFIX = "ga_sign_up_sent_";

if (isEnabled) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        // gtag.js exige el objeto `arguments`, no un array
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
}

export const trackSignUp = (tenantId) => {
    if (!isEnabled) return;
    const storageKey = `${SIGN_UP_SENT_STORAGE_PREFIX}${tenantId || ""}`;
    try {
        if (localStorage.getItem(storageKey)) return;
        localStorage.setItem(storageKey, "1");
    } catch {
        // Sin localStorage se manda igual; un duplicado ocasional es aceptable
    }
    window.gtag("event", "sign_up", { method: "google" });
};
